import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { QueryClient } from '@tanstack/react-query';
import { apiClient } from '../../lib/api-client';
import type { AnulacionSeparacion, DescarteSeparacion } from '../../types/consultas';

/**
 * feat-67: tras cerrar una separación cambian su estado (consultas) y el de sus unidades: se invalidan
 * las consultas y todo `['separations', …]`, que incluye `available-units` del paso 1 del flujo (la unidad
 * liberada vuelve a verse disponible).
 */
function invalidarTrasCierre(qc: QueryClient): void {
  // Sin `await`: la fila (o la pantalla) que lanzó la acción puede desmontarse al llegar el refetch, y
  // TanStack no ejecuta los callbacks de `mutate` de un componente desmontado.
  void qc.invalidateQueries({ queryKey: ['consultas'] });
  void qc.invalidateQueries({ queryKey: ['separations'] });
}

export function useDescartarSeparacion() {
  const qc = useQueryClient();
  return useMutation<DescarteSeparacion, Error, string>({
    mutationFn: (separacionId) => apiClient.separations.discard(separacionId),
    onSuccess: () => invalidarTrasCierre(qc),
  });
}

export function useAnularSeparacion() {
  const qc = useQueryClient();
  return useMutation<AnulacionSeparacion, Error, { separacionId: string; motivo: string; inmobiliariaId?: string }>({
    mutationFn: ({ separacionId, motivo, inmobiliariaId }) =>
      apiClient.separations.cancel(separacionId, motivo, inmobiliariaId),
    onSuccess: () => invalidarTrasCierre(qc),
  });
}
